import { isEmpty } from 'lodash'

export default (searchedBy, filters, agenda) => {
  if (!isEmpty(agenda.professional.id)) {
    filters['professional'] = agenda.professional
    searchedBy.push(agenda.professional.name)
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/advanced/resources/filters/filterByProfessional.js